<template>
    <div class="jp" v-cloak id="app">
        <div class="box clearfloat">
            <div class="box_fl" style="width: 519px;">
                <h1 class="fl_title">
                    <i class="icn01"></i> 竞买资源摘要
                </h1>

                <table border="1" class="tab">
                    <tr>
                        <th>项目编号</th>
                        <td colspan="3" style="max-width: 393px;line-height: 25px;word-break: break-all;">{{xmjyxq.zybh}}</td>
                    </tr>

                    <tr>
                        <th>项目名称</th>
                        <td colspan="3" style="max-width: 393px;line-height: 25px;word-break: break-all;">{{xmjyxq.xmmc}}</td>
                    </tr>

                    <tr>
                        <th>项目类型</th>
                        <td colspan="3" style="max-width: 393px;line-height: 25px;word-break: break-all;">{{xmjyxq.xmlx}}</td>
                    </tr>

                    <tr>
                        <th>拍卖开始时间</th>
                        <td>{{xmjyxq.gpqssj}}</td>
                        <th>限时竞拍时间</th>
                        <td>{{xmjyxq.gpjzsj}}</td>
                    </tr>
                    <tr>
                        <th>延时周期</th>
                        <td>{{xmjyxq.timeLimitedBiddingCycle}}分钟/次</td>
                        <th>延时次数</th>
                        <td>2次</td>
                    </tr>
                    <tr>
                        <th>起始价</th>
                        <td><span style="color: red;">{{xmjyxq.qsj}}</span> {{xmjyxq.jgdw}}</td>
                        <th>增价幅度</th>
                        <td>{{xmjyxq.zjfd}}{{xmjyxq.jgdw}}</td>
                    </tr>
                    <tr>
                        <th>有无底价</th>
                        <td colspan="3">{{xmjyxq.sfydj}}</td>
                    </tr>
                    <tr v-if="xmjyxq.sfszyxqr==='无'">
                        <th>优先权人</th>
                        <td colspan="3" style="max-width: 393px;line-height: 25px;word-break: break-all;">无</td>
                    </tr>
                    <tr v-if="xmjyxq.sfszyxqr==='有'">
                        <th>优先权人</th>
                        <td>有</td>
                        <th>等待行权时间</th>
                        <td>{{xmjyxq.ddhqsjf}}分钟</td>
                    </tr>
                </table>

            </div>
            <div class="ri" v-if="jjxq.sfjjz===1">
                <div class="ri_title" v-if="jjxq.cur_time <= xmjyxq.freeEndTime">
                    <i class="icn3" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02.png') + ')'}"></i>
                    <span>正在拍卖</span>
                </div>

                <div class="ri_title" v-if="jjxq.cur_time > xmjyxq.freeEndTime">
                    <span style="color:red;">最高价第{{jjxq.djczgbj}}次叫价</span>
                </div>

                <div class="item">
                    <template v-if="jjxq.cur_time > xmjyxq.freeEndTime">
                        <p class="item_sheng">
                            本次剩余时间：<span style="color: red;"></span>
                        </p>
                        <div class="item_dao clearfloat">
                            <p class="item_dao_fl">{{jjxq.zgbjdsms | tsByMiao}}</p>
                            <p>天</p>
                            <p class="item_dao_fl">{{jjxq.zgbjdsms | xsByMiao}}</p>
                            <p>:</p>
                            <p class="item_dao_fl">{{jjxq.zgbjdsms | fzByMiao}}</p>
                            <p>:</p>
                            <p class="item_dao_fl">{{jjxq.zgbjdsms | msByMiao}}</p>
                        </div>
                    </template>

                    <template v-if="jjxq.cur_time <= xmjyxq.freeEndTime">
                        <p class="item_sheng">
                            交易剩余时间
                        </p>
                        <div class="item_dao clearfloat">
                            <p class="item_dao_fl">{{jjxq.day}}</p>
                            <p>天</p>
                            <p class="item_dao_fl">{{jjxq.hour}}</p>
                            <p>:</p>
                            <p class="item_dao_fl">{{jjxq.minute}}</p>
                            <p>:</p>
                            <p class="item_dao_fl">{{jjxq.second}}</p>
                        </div>
                    </template>

                </div>
                <div class="dangqian">
                    <p>当前最高出价</p>
                    <p v-if="jjxq.dqzgj && !noCj">
                        <span style="color: red;" v-text="jjxq.dqzgj">0</span>
                        <b style="font-weight: 400;" v-text="' '+xmjyxq.jgdw"></b>
                    </p>
                    <p v-else>
                        <span style="color: red;">暂无报价</span>
                    </p>
                </div>
            </div>

            <div class="ri" v-if="jjxq.sfjjz===2">
                <div class="ri_title">
                    <i class="icn3"></i>
                    <span>竞价未开始</span>
                </div>
            </div>

            <div class="ri" v-if="jjxq.sfjjz===3 && xmjyxq.sfszyxqr==='无'">
                <template v-if="jjxq.jjjl.length>0">
                    <div class="ri_title" v-if="sfcj===null">
                        <span>交易结果正在确认，请稍等</span>
                    </div>
                    <div class="ri_title" v-else-if="sfcj">
                        <i class="icn32" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_2.png') + ')'}"></i>
                        <span style="color:red;">已成交</span>
                    </div>

                    <div class="ri_title" v-else-if="sfcj">
                        <i class="icn33" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_4.png') + ')'}"></i>
                        <span>已流拍</span>
                    </div>
                </template>

                <template v-if="jjxq.jjjl.length===0">
                    <div class="ri_title">
                        <i class="icn33" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_4.png') + ')'}"></i>
                        <span>已流拍</span>
                    </div>
                </template>


                <div class="item">
                    <p class="item_sheng">
                        交易剩余时间
                    </p>
                    <div class="item_dao clearfloat">
                        <p class="item_dao_fl">0</p>
                        <p>天</p>
                        <p class="item_dao_fl">0</p>
                        <p>:</p>
                        <p class="item_dao_fl">0</p>
                        <p>:</p>
                        <p class="item_dao_fl">0</p>
                    </div>
                </div>
                <div class="dangqian">
                    <p>当前最高出价</p>
                    <p v-if="jjxq.dqzgj && !noCj">
                        <span style="color: red;" v-text="jjxq.dqzgj">0</span>
                        <b style="font-weight: 400;" v-text="' '+xmjyxq.jgdw"></b>
                    </p>
                    <p v-else>
                        <span style="color: red;">暂无报价</span>
                    </p>
                </div>
            </div>

            <div class="ri" v-if="jjxq.sfjjz===3 && xmjyxq.sfszyxqr==='有'">
                <template v-if="xsyxq.sfxq!==''">
                    <div class="ri_title" v-if="sfcj===null">
                        <span>交易结果正在确认，请稍等</span>
                    </div>
                    <div class="ri_title" v-else-if="sfcj">
                        <i class="icn32" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_2.png') + ')'}"></i>
                        <span style="color:red;">已成交</span>
                    </div>

                    <div class="ri_title" v-else-if="sfcj">
                        <i class="icn33" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02_4.png') + ')'}"></i>
                        <span>已流拍</span>
                    </div>
                </template>

                <template v-else>
                    <div class="ri_title">
                        <i class="icn3" :style="{backgroundImage:'url(' + require('../assets/Jmxx/img/02.png') + ')'}"></i>
                        <span>等待行使优先权</span>
                    </div>
                </template>


                <div class="item">
                    <p class="item_sheng" v-if="xsyxq.sfxq===''">
                        正在等待行使优先权
                    </p>
                    <p class="item_sheng" v-if="xsyxq.sfxq!==''">
                        交易剩余时间
                    </p>
                    <div class="item_dao clearfloat">
                        <p class="item_dao_fl">{{xsyxq.day}}</p>
                        <p>天</p>
                        <p class="item_dao_fl">{{xsyxq.hour}}</p>
                        <p>:</p>
                        <p class="item_dao_fl">{{xsyxq.minute}}</p>
                        <p>:</p>
                        <p class="item_dao_fl">{{xsyxq.second}}</p>
                    </div>
                </div>
                <div class="dangqian">
                    <p>当前最高出价</p>
                    <p v-if="jjxq.dqzgj && !noCj">
                        <span style="color: red;" v-text="jjxq.dqzgj">0</span>
                        <b style="font-weight: 400;" v-text="' '+xmjyxq.jgdw"></b>
                    </p>
                    <p v-else>
                        <span style="color: red;">暂无报价</span>
                    </p>
                </div>
            </div>


        </div>

        <div class="box2">
            <h2>
                <i class="icn05"></i> 出价记录
            </h2>
            <div class="box2_cont">
                <div class="box2_cont_title clearfloat">
                    <p>出价序号</p>
                    <p>竞买人报价</p>
                    <p>时间</p>
                </div>
                <div class="box2_cont_title clearfloat con_acti box2_cont_title11" style="margin-top: 10px;" v-for="(value, index) in jjxq.jjjl" :key="index">
                    <p class="cont_chujia">
                        <span>{{value.xh || jjxq.jjjl.length - index}}</span>
                        <span v-if="value.bidderId===xmjyxq.bmjgID">我的出价</span>
                    </p>
                    <p>
                        {{value.quotePrice}} {{xmjyxq.jgdw}}
                    </p>
                    <p>
                        {{value.quoteTime}}
                    </p>
                </div>
                <div class="tips" v-if="jjxq.jjjl !== undefined && jjxq.jjjl !== null && jjxq.jjjl.length<=0">找不到和您的查询相符的记录</div>
            </div>
        </div>

    </div>
</template>

<script>
    import {api} from '@/core/api'

    let dycxs = true;

    export default {
        name: "JmxxZrpm",
        props: ["detail"],
        data() {
            return {
                xmjyxq: {  //交易项目信息
                    "ywlxID": "",
                    "bmjgID": "",
                    "jjsID": "",
                    "ggh": "",
                    "xmmc": "",
                    "zybh": "",
                    "bdlx": "",
                    "jyfs": "",
                    "gpqssj": "",
                    "gpjzsj": "",
                    "qsj": "",
                    "zjfd": "",
                    "jgdw": "",
                    "jgfs": "",
                    "sfydj": "",
                    "jmh": "",
                    "jmr": "",
                    "djwy": "",
                    "xmdj": "",
                    "fjy": "",
                    "sfszyxqr": "",
                    "sfyxqr": "",
                    "ddhqsjf": "",
                    "zjfsCode": "",
                    "cjjls": 0,
                    "freeEndTime": "",
                    "timeLimitedBiddingCycle": "",
                    "timeLimitedBiddingCycleNum": "",
                    "sfbmcg": "", //是否报名成功，2报名未成功，1报名已成功、
                    "xmlx": ""
                },
                jjxq: {  //竞价信息
                    "dqzgj": "", //当前最高价
                    "wxcjNum": "", //我想出价数字
                    "sdjj": "", //手动加价
                    "jjfs": "1",//加价方式
                    "cjbs": "1", //出价倍数
                    "jjjl": [], //竞价记录
                    "sfjjz": "0", //是否竞价中
                    "gpjzsj": "",
                    "day": "", //剩余天数
                    "hour": "", //小时
                    "minute": "", //分钟
                    "second": "", //秒
                    "cur_time": "",
                    "djczgbj": "",
                    "zgbjdsms": ""
                },
                xsyxq: {
                    "day": "",
                    "ddhqsjf": "",
                    "hour": "",
                    "minute": "",
                    "second": "",
                    "sfszyxqr": "",
                    "sfxq": ""
                },
                djs: {
                    "day": "",
                    "hour": "",
                    "minute": "",
                    "second": "",
                },
                xsjjPop: false,
                sfcj: null,
                timer1: null,
                timer2: null,
                timer3: null,
            }
        },
        mounted() {
            api.getXmjyxq({jyywlx: '03', jyID: this.detail.jyID}).then(response => {
                if (response.data) {
                    this.xmjyxq = response.data;
                    this.getJmxx();
                }
            });
        },
        methods: {
            getJmxx() {
                api.getJmxx({jyywlx: '03', jjsID: this.xmjyxq.jjsID}).then(response => {
                    if (this.jjxq.cur_time !== "" && this.xmjyxq.freeEndTime !== "") {
                        if (dycxs && this.jjxq.cur_time > this.xmjyxq.freeEndTime && response.data.sfjjz === 1) {
                            this.xsjjPop = true;
                            dycxs = false;
                        }

                        if (this.jjxq.cur_time > this.xmjyxq.freeEndTime && response.data.gpjzsj > this.jjxq.gpjzsj && response.data.sfjjz === 1) {
                            this.xsjjPop = true;
                        }
                    }
                    if (response.data) {
                        this.jjxq.dqzgj = response.data.dqzgj;
                        this.jjxq.jjjl = eval("(" + response.data.jjjl + ")");
                        this.jjxq.sfjjz = response.data.sfjjz;
                        this.jjxq.gpjzsj = response.data.gpjzsj;

                        this.jjxq.day = response.data.day;
                        this.jjxq.hour = response.data.hour;
                        this.jjxq.minute = response.data.minute;
                        this.jjxq.second = response.data.second;
                        this.jjxq.cur_time = response.data.cur_time;

                        let zsyms = parseInt(response.data.minute) * 60 + parseInt(response.data.second); //总剩余秒数
                        let zgsj = parseInt(this.xmjyxq.timeLimitedBiddingCycle) * 60; //锤定一次间隔时间
                        let zgbjdsms = zsyms % zgsj;
                        this.jjxq.zgbjdsms = zgbjdsms; //最高报价锤定倒数秒数
                        let djczgbj = this.xmjyxq.timeLimitedBiddingCycleNum - parseInt(zsyms / zgsj) - 1;
                        this.jjxq.djczgbj = djczgbj; //最高报价锤定倒数秒数


                        if (this.jjxq.sfjjz === 3) {
                            this.getSfcj();
                            if (this.xmjyxq.sfszyxqr === '有') {
                                this.getXqxq()
                            }
                        } else {
                            this.timer1 = setTimeout(this.getJmxx, 1000)
                        }
                    }
                })
            },
            getSfcj() {
                api.getDetailById({category: "Gtzy", id: this.detail.id}).then(response => {
                    this.sfcj = response.data.extData.sfpmcg;
                    if (this.sfcj === null) {
                        this.time2 = setTimeout(this.getSfcj, 1000)
                    }
                });
            },
            getXqxq() {
                api.getXqxq({jyywlx: '03', jyID: this.detail.jyID}).then(response => {
                    this.xsyxq = response.data;
                    if (this.xsyxq.sfxq === "") {
                        this.timer3 = setTimeout(this.getXqxq, 1000);
                    }
                });
            }
        },
        filters: {
            tsByMiao(value){
                return Math.floor(value / 60 / 60 / 24);
            },
            xsByMiao(value){
                return Math.floor(value / 60 / 60 % 24);
            },
            fzByMiao(value){
                return Math.floor(value / 60 % 60);
            },
            msByMiao(value){
                return Math.floor(value % 60);
            }
        },
        beforeDestroy() {
            clearTimeout(this.timer1);
            clearTimeout(this.timer2);
            clearTimeout(this.timer3);
        },
        computed: {
            noCj() {
                return this.jjxq.jjjl !== undefined && this.jjxq.jjjl !== null && this.jjxq.jjjl.length <= 0;
            }
        }
    }
</script>
<style scoped src="../assets/Jmxx/css/index.css"></style>
<style scoped src="../assets/Jmxx/css/reset.css"></style>
<style scoped>
    .b_red {
        background-color: #fff8da;
    }

    .item_dao .item_dao_fl {
        width: 40px;
        height: 25px;
        background-image: linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        background-image: -moz-linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        background-image: -webkit-linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        background-image: -ms-linear-gradient(90deg, rgb(223, 55, 55) 0%, rgb(255, 125, 99) 99%);
        border-radius: 20px;
        text-align: center;
        line-height: 25px;
        color: #fff;
        margin: 0;
    }

    .xianshi .icn_1 {
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 30px;
    }

    .ri_title .icn3 {
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 30px;
    }

    .wanok .icn_2 {
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 30px;
    }

    .tips {
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #a6a6a6;
        margin-top: 10px;
    }

    .tab th {
        height: 39px;
        background-color: #f8f8f8;
        font-size: 14px;
        padding-right: 10px;
        padding-left: 8px;
        opacity: .5;
        text-align: left;
        font-weight: 700;
    }

    .tab td {
        padding: 0 10px;
        font-size: 14px;
        width: 135px;
    }

    .fl_title .icon06 {
        display: inline-block;
        width: 26px;
        height: 26px;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-left: 30px;
    }
</style>
